'use client';

import {useEffect,useRef} from 'react';

type Lang='zh'|'en'|'ja'|'es';
const labels:Record<Lang,string>={zh:'返回顶部',en:'Back to top',ja:'トップへ戻る',es:'Volver arriba'};

export default function BackToTop({lang}:{lang:Lang}){
  const btn=useRef<HTMLButtonElement>(null);
  useEffect(()=>{
    const el=btn.current;
    if(!el)return;
    const onScroll=()=>{
      const top=window.scrollY||document.documentElement.scrollTop;
      el.classList.toggle('visible',top>320);
    };
    onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
    return()=>window.removeEventListener('scroll',onScroll);
  },[]);
  return <button ref={btn} id="go-to-up" title={labels[lang]} aria-label={labels[lang]} onClick={()=>window.scrollTo({top:0,behavior:'smooth'})}>↑</button>;
}
